import { FC, forwardRef, Ref } from 'react';
import { IonHeader, IonMenuToggle, IonFooter, IonToolbar } from '@ionic/react';
import {
  StyledChevronBackOutline,
  StyledDrawer,
  StyledDrawerContent,
  StyledIconContainer,
  ToolbarHeader,
} from './Drawer.styles';
import { AllieDrawerButtonProps, AllieDrawerProps } from './Drawer.types';
import { AllieCloseOutlineIcon } from '../../styling/icons';
import { AllieButton } from '../Buttons/Button';
import { AllieLink } from '../Buttons/Link';
import { AllieText } from '../Text';
import './Drawer.css';
import { AllieIconButton } from '../Buttons/IconButton';

export const AllieDrawer: FC<AllieDrawerProps> = forwardRef(
  (
    {
      children,
      width,
      title,
      subtitle,
      contentId,
      closeButton = true,
      closeButtonText = 'Close',
      saveButton = true,
      saveButtonText = 'Save',
      swipeGesture = false,
      onSave,
      disableSave = false,
      saveButtonLoading = false,
      isMobile = false,
      onClose,
      onDidClose,
      ...props
    }: AllieDrawerProps,
    ref
  ) => {
    return (
      <StyledDrawer
        side="end"
        id="right-drawer"
        menuId="right-drawer"
        contentId={contentId}
        type="overlay"
        width={width}
        class="allie-drawer"
        ref={ref as Ref<HTMLIonMenuElement>}
        swipeGesture={swipeGesture}
        onIonDidClose={onDidClose}
        {...props}
      >
        <IonHeader className="ion-no-border">
          <IonToolbar className="toolbar-header padding-content">
            <ToolbarHeader isMobile={isMobile}>
              {isMobile && (
                <AllieIconButton
                  type="secondary"
                  corner="rounded-edges"
                  allieSize="xs"
                  onclick={onClose}
                >
                  <StyledChevronBackOutline />
                </AllieIconButton>
              )}
              <div style={{ maxWidth: closeButton ? '60%' : 'auto' }}>
                <AllieText className="allie-drawer-header-text" color="neutral" type="h4">
                  {title}
                </AllieText>
                <AllieText className="allie-drawer-header-text" color="neutral-90" type="field2">
                  {subtitle}
                </AllieText>
              </div>
              {!isMobile && closeButton && (
                <IonMenuToggle menu="right-drawer" autoHide={false}>
                  <StyledIconContainer onClick={onClose}>
                    {closeButtonText}
                    <AllieCloseOutlineIcon style={{ width: 20, height: 20 }} />
                  </StyledIconContainer>
                </IonMenuToggle>
              )}
            </ToolbarHeader>
          </IonToolbar>
        </IonHeader>
        <StyledDrawerContent scrollY={false}>{children}</StyledDrawerContent>
        {saveButton && (
          <IonFooter>
            <IonToolbar className="padding-content">
              {saveButton && (
                <AllieButton
                  slot="end"
                  allieSize="small"
                  corner="rounded-edges"
                  style={{ height: '40px', margin: 0 }}
                  onclick={onSave}
                  disabled={disableSave}
                  loading={saveButtonLoading}
                >
                  {saveButtonText}
                </AllieButton>
              )}
            </IonToolbar>
          </IonFooter>
        )}
      </StyledDrawer>
    );
  }
);

export const AllieDrawerButton: FC<AllieDrawerButtonProps> = ({
  type,
  value,
  buttonProps,
  linkProps,
}) => {
  return (
    <IonMenuToggle menu="right-drawer" autoHide={false}>
      {type === 'button' ? (
        <AllieButton {...buttonProps}>{value}</AllieButton>
      ) : (
        <AllieLink {...linkProps}>{value}</AllieLink>
      )}
    </IonMenuToggle>
  );
};
